import React from 'react';
import { render } from 'react-dom';
import img from "../../../public/assets/images/ajax-loader-big.gif";

const centeredStyle = {
    display: 'block',
    margin: 'auto'
}

class Loader extends React.Component {
    render() {

        return (
            <img
                style={centeredStyle}
                src={img}
            />
        );
    }
}
export default Loader;  